import 'ui-core/components/coolbar/js/coolbar';

UX.coolbar.vPort = ['screen-md'];
